import checkingAccountStatement from './checking-account-statement'

export default {
  namespaced: true,
  modules: {
    checkingAccountStatement,
  },
  state: {},
  mutations: {},
  actions: {},
}
